import Swiper from 'swiper';

class SliderActuEvent {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-actu__slider', {
      direction: 'horizontal',
      grabCursor: true,
      preventInteractionOnTransition: true,
      slidesPerView: 'auto',
      spaceBetween: 24
      // breakpoints: {
      //   1025: {
      //     slidesPerView: 'auto',
      //     spaceBetween: 24
      //   }
      // }
    });
  }
}

export const sliderActuEvent = new SliderActuEvent();
